import LoaderView from "../views/loader.html";

class LoaderController {
    constructor($scope, $attrs) {
        'ngInject';
        this.$scope = $scope;
        this.$attrs = $attrs;
    }
}

let loaderComponent = {
    bindings: {},
    template: LoaderView,
    transclude: true,
    controller: LoaderController
};

export default loaderComponent;
